module.exports = __webpack_public_path__ + "media/images/associate_degree-cf024b6c1f27e2942108965539adb0c7.png";